import React from 'react';
import { useAuthStore } from '../store/useAuthStore';
import TaskManagement from '../components/tasks/TaskManagement';

const TaskManagementPage = () => {
  const { user } = useAuthStore();
  
  return <TaskManagement currentUser={user} />;
};

export default TaskManagementPage;
